import { render, staticRenderFns } from "./OrderInList.vue?vue&type=template&id=213ba727&scoped=true&"
import script from "./OrderInList.vue?vue&type=script&lang=js&"
export * from "./OrderInList.vue?vue&type=script&lang=js&"
import style0 from "./OrderInList.vue?vue&type=style&index=0&id=213ba727&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ba727",
  null
  
)

export default component.exports